module.exports = __webpack_public_path__ + "img/Resources.566b6a98.webp";